import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRouterDom from 'react-router-dom';
import * as queryString from 'query-string';
import { connect } from 'react-redux';
import { REDIRECT_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';

const PublicRoute = (p) => {
  const { tj_access_token } = queryString.parse(window.location.search);
  const {
    loggedIn, component: Component, componentProps, ...rest
  } = p;

  if (loggedIn && !tj_access_token) {
    const params = new URLSearchParams(window.location.search);
    const redirectTo = params.get(REDIRECT_URL_SEARCH_PARAM) || ROUTE_PATH[ROUTE_NAME.FEED];
    return <ReactRouterDom.Redirect to={redirectTo} />;
  }

  return (
    <ReactRouterDom.Route
      {...rest}
      render={(props) => <Component {...componentProps ?? {}} {...props} />}
    />
  );
};

const mapStateToProps = (state) => ({
  loggedIn: !!(state.authentication && state.authentication.loggedIn && state.authentication.user),
});

PublicRoute.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  componentProps: PropTypes.object,
};

export default ReactRouterDom.withRouter(connect(mapStateToProps)(PublicRoute));
